import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";

@Injectable()
export class LeadsMultipleStepByStepService {
  private cancel = new Subject<boolean>();
  private nextStep = new Subject<boolean>();

  cancelLoading() {
    this.cancel.next(true);
  }

  switchToNextStep() {
    this.nextStep.next(true);
  }

  listenToCancel(): Observable<boolean> {
    return this.cancel;
  }

  listenToNextStep(): Observable<boolean> {
    return this.nextStep;
  }
}
